import React from 'react';
import {
	nowMoment,
	toMoment,
} from '@shared/utils/date';
import { DATE_AND_TIME } from '@shared/utils/constants';
import { formatAndRoundNumber } from '@shared/utils/formatNumber';
import type { VesselWithPosition } from '@api/features/geo/getVesselsWithPositions';
import { formatDate } from '@client/utils/formatDate';
import VesselDescription from '@client/components/VesselDescription';
import LinkButton from '@client/components/LinkButton';
import { Links } from '@client/utils/links';
import TooltipIcon from '@client/components/TooltipIcon';

const getVesselMarkerDetails = (vessel: VesselWithPosition) => {
	const { timestamp } = vessel.position;

	const formattedDate = formatDate(new Date(timestamp), DATE_AND_TIME);

	const now = nowMoment();

	const datetime = toMoment(timestamp);

	const outdated = now.diff(datetime, 'days') > 1;

	const vesselDetails = [{
		key: 'name',
		label: 'Name',
		value: (
			<LinkButton
				url={Links.Vessel.get(vessel.id)}
			>
				<VesselDescription
					name={vessel.name}
					flag={vessel.flag}
				/>
			</LinkButton>
		),
	},
	{
		key: 'coordinates',
		label: 'Coordinates',
		value: `
			${formatAndRoundNumber(vessel.position.latitude, 3)}° / 
			${formatAndRoundNumber(vessel.position.longitude, 3)}°
		`,
	},
	{
		key: 'contract',
		label: 'Contract',
		value: vessel.voyageId == null ? (
			vessel.voyageIdentifier
		) : (
			<LinkButton url={Links.Voyage.get(vessel.voyageId)}>{vessel.voyageIdentifier}</LinkButton>
		),
	},
	{ key: 'charterer', label: 'Charterer', value: vessel.chartererName },
	{ key: 'openDate', label: 'Open Date', value: formatDate(vessel.openDate ?? null, DATE_AND_TIME) },
	{
		key: 'positionReceived',
		label: 'Position received',
		value: outdated ? (
			<span style={{ color: 'red' }}>
				{formattedDate}
				<TooltipIcon danger>
					Data is more than one day old
				</TooltipIcon>
			</span>
		) : formattedDate,
	},
	];

	return { vesselDetails, outdated };
};

export default getVesselMarkerDetails;
